"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAxiosClient = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const axios_retry_1 = tslib_1.__importStar(require("axios-retry"));
const defaultRetryCondition = (error) => {
    var _a;
    const shouldRetry = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status.toString().startsWith('5')) === true;
    return shouldRetry;
};
const createAxiosClient = ({ baseUrl, numRetries = 0, retryCondition = defaultRetryCondition, timeoutMs = 5000, }) => {
    const axiosInstance = axios_1.default.create({ baseURL: baseUrl, timeout: timeoutMs });
    const axiosRetryConfig = {
        retries: numRetries,
        retryCondition,
        retryDelay: axios_retry_1.exponentialDelay,
        shouldResetTimeout: true,
    };
    (0, axios_retry_1.default)(axiosInstance, axiosRetryConfig);
    return axiosInstance;
};
exports.createAxiosClient = createAxiosClient;
//# sourceMappingURL=axios.js.map